export default class ObjectPool {
    constructor() {
        this.pool = {};
    }

    push(key, obj) {
        if(!this.pool[key]) {
            this.pool[key] = [];
        }
        this.pool[key].push(obj);
    }

    pop(key) {
        let obj = null;
        if(this.pool[key] && this.pool[key].length) {
            obj = this.pool[key].pop();
        }
        return obj;
    }

    clear() {
        for(let arr in this.pool) {
            let len = arr.length;
            while(--len > -1) {
                let item = arr.pop();
                if(item.dispose) {
                    item.dispose();
                }
            }
        }
    }

    dispose() {
        clear();
        this.pool = null
    }
}



// WEBPACK FOOTER //
// ./src/common/scripts/pixi/ObjectPool.js